import marks from './marks';

export default function clearMarks() {
	marks.length = 0;
}
